// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.65 5.76C6.28 4.32 9.67 3.13 13.15 2.08C13.77 1.89 14.11 2.23 13.92 2.85C12.87 6.33 11.68 9.72 10.24 13.35C10.05 13.83 9.6 13.89 9.39 13.36C9.21 11.8 8.59 10.35 7.68 9.14C7.44 8.82 7.18 8.56 6.86 8.32C5.65 7.41 4.2 6.79 2.64 6.61C2.11 6.4 2.17 5.95 2.65 5.76Z',
  'M13.62 2.38L7.3 8.7',
];
